import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class CandlemakerBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.CANDLEMAKER;
}

export default CandlemakerBuildingTileEntity;
